import { useState } from "react";
import Panel from "../components/Panel";
import Bio from "../components/Bio";
import CarouselButton from "../components/CarouselButton";
import {
  balldefender,
  cookulator,
  choihung,
  herolog,
  montoutimer,
  micoquiz,
  pickleparty,
  shangchi,
  stawamus,
  stawamus_gungfu,
  theysent100,
} from "../assets";
import * as Constants from "../constants/Constants";
import "../styles/Carousel.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;

const Carousel = () => {
  const [clickedOnce, setClickedOnce] = useState(false);
  const [showBio, setShowBio] = useState(false);

  return (
    <div onClick={() => setClickedOnce(true)}>
      {!showBio && (
        <div id="title" onClick={() => setShowBio(true)}>
          RYAN TONG
        </div>
      )}
      <div style={{ visibility: showBio ? "visible" : "hidden" }}>
        <div className="swiper-button image-swiper-button-next">
          <IoIosArrowForward />
        </div>
        <div className="swiper-button image-swiper-button-prev">
          <IoIosArrowBack />
        </div>
      </div>

      <Swiper
        navigation={{
          nextEl: ".image-swiper-button-next",
          prevEl: ".image-swiper-button-prev",
        }}
        modules={[Navigation]}
        id="carousel"
      >
        <SwiperSlide>
          {showBio && (
            <Bio
              showBio={showBio}
              setShowBio={setShowBio}
              title={Constants.BIO_SOFTWARE_ENGINEER_TITLE}
              text={Constants.BIO_SOFTWARE_ENGINEER_DESC}
              table={
                <div className="carousel-table-grid">
                  <CarouselButton
                    desc={Constants.BIO_HEROLOG_DESC}
                    text="herolog"
                    img={`url(${herolog})`}
                    link={"https://www.herolog.net/"}
                  />
                  <CarouselButton
                    desc={Constants.BIO_PICKLEPARTY_DESC}
                    text="pickleparty"
                    img={`url(${pickleparty})`}
                    link={
                      "https://play.google.com/store/apps/details?id=com.rrtong.pickleparty"
                    }
                  />
                  <CarouselButton
                    desc={Constants.BIO_THEY_SENT_100_DESC}
                    text="they sent 100"
                    img={`url(${theysent100})`}
                    link={"https://lopsoplo.itch.io/they-sent-100"}
                  />
                  <CarouselButton
                    desc={Constants.BIO_COOKULATOR_DESC}
                    text="cookulator"
                    img={`url(${cookulator})`}
                    link={"https://cookulatr.vercel.app"}
                  />
                  <CarouselButton
                    desc={Constants.BIO_MONTOU_TIMER_DESC}
                    text="montou timer"
                    img={`url(${montoutimer})`}
                    link={"https://montou-timer.vercel.app"}
                  />
                  <CarouselButton
                    desc={Constants.BIO_MICOQUIZ_DESC}
                    text="micoquiz"
                    img={`url(${micoquiz})`}
                    link={"https://micoquiz.vercel.app"}
                  />
                  <CarouselButton
                    desc={Constants.BIO_SHANGCHI_DISCORD_BOT_DESC}
                    text="shang-chi discord bot"
                    img={`url(${shangchi})`}
                    link={"https://github.com/rrtong/shang-chi-discord-ai"}
                  />
                </div>
              }
              footer={Constants.LINKS}
            ></Bio>
          )}
          <Panel
            showBio={showBio}
            setShowBio={setShowBio}
            background={stawamus}
            subtitle={Constants.BIO_SOFTWARE_ENGINEER_TITLE}
            footer={Constants.LINKS}
          />
        </SwiperSlide>
        <SwiperSlide>
          {showBio && (
            <Bio
              showBio={showBio}
              setShowBio={setShowBio}
              title={Constants.BIO_MARTIAL_ARTIST_TITLE}
              text={Constants.BIO_MARTIAL_ARTIST_DESC}
              table={
                <div className="carousel-table-flex">
                  <div className="carousel-table-row">
                    <div>
                      <div>2023</div>
                      <div>6 months</div>
                    </div>
                    <div>muay thai </div>
                  </div>
                  <div className="carousel-table-row">
                    <div>
                      <div>2022-2023</div>
                      <div>6 months</div>
                    </div>
                    <div>taekwondo</div>
                  </div>
                  <div className="carousel-table-row">
                    <div>
                      <div>2022</div>
                      <div>3 months</div>
                    </div>
                    <div>muay thai</div>
                  </div>
                  <div className="carousel-table-row">
                    <div>
                      <div>2019</div>
                      <div>3 months</div>
                    </div>
                    <div>brazilian jiujitsu</div>
                  </div>
                  <div className="carousel-table-row">
                    <div>
                      <div>2016-2019</div>
                      <div>3 years</div>
                    </div>
                    <div>wing chun</div>
                  </div>
                </div>
              }
            ></Bio>
          )}

          <Panel
            showBio={showBio}
            setShowBio={setShowBio}
            background={stawamus_gungfu}
            subtitle={Constants.BIO_MARTIAL_ARTIST_TITLE}
          />
        </SwiperSlide>
        <SwiperSlide>
          {showBio && (
            <Bio
              showBio={showBio}
              setShowBio={setShowBio}
              title={Constants.BIO_GAMER_TITLE}
              text={Constants.BIO_GAMER_DESC}
              table={
                <div className="carousel-table-flex">
                  <div className="carousel-table-row">
                    Approximate online-gaming timeline:
                  </div>
                  <div>
                    <div className="carousel-table-row">
                      <div>2000-2001</div>
                      <div>StarCraft: Brood War</div>
                    </div>
                    <div className="carousel-table-row">
                      <div>2001-2002</div>
                      <div>Gunbound</div>
                    </div>
                    <div className="carousel-table-row">
                      <div>2001-2004</div>
                      <div>RuneScape</div>
                    </div>
                    <div className="carousel-table-row">
                      <div>2003-2011</div>
                      <div>MapleStory</div>
                    </div>
                    <div className="carousel-table-row">
                      <div>2008-2012</div>
                      <div>Rumble Fighter</div>
                    </div>
                    <div className="carousel-table-row">
                      <div>2012-2014</div>
                      <div>Elsword</div>
                    </div>
                    <div className="carousel-table-row">
                      <div>2015-2016</div>
                      <div>Guild Wars 2</div>
                    </div>
                    <div className="carousel-table-row">
                      <div>2014-2020</div>
                      <div>League of Legends</div>
                    </div>
                    <div className="carousel-table-row">
                      <div>2020-2022</div>
                      <div>Genshin Impact</div>
                    </div>
                    <div className="carousel-table-row">
                      <div>2020-2022</div>
                      <div>Valorant</div>
                    </div>
                  </div>
                </div>
              }
            ></Bio>
          )}

          <Panel
            showBio={showBio}
            setShowBio={setShowBio}
            background={balldefender}
            subtitle={Constants.BIO_GAMER_TITLE}
          />
        </SwiperSlide>
        <SwiperSlide>
          {showBio && (
            <Bio
              showBio={showBio}
              setShowBio={setShowBio}
              title={Constants.BIO_HUMAN_TITLE}
              text={Constants.BIO_HUMAN_DESC}
            ></Bio>
          )}

          <Panel
            showBio={showBio}
            setShowBio={setShowBio}
            background={choihung}
            subtitle={Constants.BIO_HUMAN_TITLE}
          />
        </SwiperSlide>
      </Swiper>
      {!clickedOnce && (
        <div id="instruction" onClick={() => setShowBio(true)}>
          {isTouch ? "tap anywhere" : "click anywhere"}
        </div>
      )}
    </div>
  );
};

export default Carousel;
